module.exports = __webpack_public_path__ + "b6817304738b13c223bce37b2b89e8c6.pdf";